import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getAuth, getUser, isLoggedIn, saveCommonData } from "../utils/auth_utils";
import { NavbarTop } from "../common_components/navbar_top";
import LoginModal from "../login/email_login_modal";
import IndefiniteProgressBar from "../common_components/indefinite_progress_bar";
import { getJsonDataPostRequest } from "../utils/network_utils";
import { MdSportsGolf } from "react-icons/md";
import { MSG_ERROR_PROGRESS_UI } from "../common_components/common_ui_components";
import { homeUrl } from "../utils/common_utils";
import { LinkUITealBold } from "../common_components/common_links";

const ViewPastInterviews = () => {
  const userLoggedIn=isLoggedIn()
  const [showProgress, setShowProgress]=useState(false)
  const [message, setMessage]=useState("")
  const[error, setError]=useState("")
  const[interviews, setInterviews]=useState([])

  useEffect(() => {
    console.log("loading interview details..")
    let data={
      auth:getAuth(),
      lastInterviewId: -1
    }
    getJsonDataPostRequest(
      homeUrl()+"interviewApi/getPastLLDInterviews", 
      data, function(response){
      setShowProgress(false)
      if(response==null||response.status>=400){
         setError(response.message || "Some error occured, please try again")  
         return   
      }
      if(!response.interviews || response.interviews.length==0){
        setMessage(" No past interview data found")
      }
      setInterviews(response.interviews)
      saveCommonData(response)
  })

}, []); // empty bracket means there are no dependencies which will make useEffect re run

 return (
   <div>
   
   {/* below is the actual UI that user will see on laptop/desktop or any other wide screen */}
   <div className=" flex flex-col h-full w-full
     items-center justify-center ">
     <NavbarTop />
     <div className="mt-20 p-4"></div>
    {
      !userLoggedIn && 
      <div className="text-center text-xl font-mono">
        <br /> <br /> <br /> <br />
        Please Login to view Past Interview Data
        <br /><br />
        <LoginModal />
        </div>
    }
    
    {userLoggedIn &&
        <div className="flex flex-col items-center justify-center w-full">
            <p className="text-2xl mb-8 ">Past Interviews</p>
            {
       <MSG_ERROR_PROGRESS_UI message={message} 
      error={error} showProgress={showProgress}/>
      }
            <br />
             {interviews && interviews.length>0 &&  
                <div className='overflow-x-auto mx-2 md:mx-0 
                 whitespace-nowrap w-full justify-center items-center'>
                {/*
                overflow-x-auto is needed to make it scroll separately from parent 
                forcing column to be in single line using whitespace-nowrap
                mx-auto in below table tag is for centering the table
                 */}
            
                <table className="table-auto mx-auto border-collapse md:w-2/3  py-8 
                md:px-8">
                  {/* used overflow-x-auto because I want scroll bars to be visible */}
                  <thead>
                    <tr className="text-gray-700 bg-white">
                   
                    <th className="px-2 py-3  text-center  text-gray-400 font-normal  ">
                        Interview Number
                      </th>
                     {<th className="px-2 py-3 ml-2  text-center  text-gray-400 font-normal ">
                       Question
                      </th> 
                     }
                      <th className="px-2 pl-6 ml-6 py-3  text-center  text-gray-400 font-normal ">
                        
                      </th> 
                    </tr>
                  </thead>
                  
                  <tbody className=' font-normal'>
                    {interviews.map((row) => (
                      <tr key={row.interviewId} className="border-b border-gray-200 hover:text-teal-700 md:px-8
                      even:white odd:bg-gray-100">
                       { <td className=" pl-6 py-3 text-xl text-center text-gray-700">
                        {row.interviewId} 
                        </td>
                      }
                        <td className="px-4 pl-1 py-3 text-center">
                         <span className=" text-sm text-gray-500">
                            </span>
                          <a href={`/question/${row.questionId}`} className="text-black hover:text-teal-600 ">
                          {row.questionHeading}</a>
                        </td>
                        <td className="px-2 pl-6 ml-6 py-3 text-center text-gray-500">
                          <LinkUITealBold text="View Details" 
                          url={`/evaluations/${row.interviewId}`}  />
                          </td>    
                      </tr>
                    ))}
                  </tbody>
            
                </table>
                
                </div>
              }
             
            {!error && !message && interviews.length==0 &&
            <div className="text-2xl font-bold text-teal-600 mt-20 ">
              Loading all Questions. <br /> Please wait ...
            </div>
            }
            <br /> <br /> <br /> <br /> 
        </div>    
    }
     </div>
     </div>
 )
}

export {ViewPastInterviews}